var _a;
import { MemberGenderType } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[MemberGenderType.F] = 'Female',
    _a[MemberGenderType.M] = 'Male',
    _a[MemberGenderType.O] = 'Other',
    _a[MemberGenderType.U] = 'Undefined',
    _a);
export var MemberGenderTypeEnum = {
    name: 'MemberGenderType',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
